import "./index.css";
import React, { memo } from "react";
import { FaPlus, FaRandom } from "react-icons/fa";
import { Handle } from "reactflow";

import { ValidatorFn } from "../../../helpers/validationConnector";
import { NodeHeader } from "../../Elements/NodeHeader";
import { NodeRef } from "../../Elements/NodeRef";

export default memo(({ data, ...rest }) => {
	return (
		<>
			<NodeRef nodeRef={data.ref} />
			<Handle
				type="target"
				position="left"
				isConnectable={true}
				isConnectableStart={false}
			/>

			<NodeHeader
				data={data}
				rest={rest}
				icon={<FaRandom />}
				text="Balanceador de saídas"
			/>

			<div className="questionButtons">
				{data.balancerOutputs &&
					data.balancerOutputs.map((output, i) => (
						<Item
							key={i}
							i={i}
							output={output}
							isLast={i === data.balancerOutputs.length - 1}
						/>
					))}
			</div>
		</>
	);
});

function Item({ i, output, isLast }) {
	return (
		<div className={isLast ? "item-last" : ""}>
			<div className="conditionalContent balancer-output-item">
				<span className="output-name">{output.name}</span>
				<span className="output-percentage">{output.percentage}%</span>
			</div>
			<Handle
				type="source"
				position="right"
				id={output.name}
				className="handle"
				isConnectable={true}
				isValidConnection={ValidatorFn()}
			>
				<FaPlus size={8} style={{ pointerEvents: "none" }} />
			</Handle>
		</div>
	);
}
